import React, { useCallback } from 'react'
import { makeStyles, ButtonBase, Icon } from '@material-ui/core'
import { formatBytes } from '../../../utils'
import { gray } from '../../../utils/colors'

const FileReferenceIndicator = ({ fileName = '', fileSize = 0, fileUrl = '', onDelete }) => {
	const classes = useStyles()
	const handleOnDelete = useCallback(() => {
		if (onDelete) {
			onDelete()
		}
	}, [onDelete])

	return (
		<div className={classes.root}>
			<div className={classes.textContainer}>
				{fileUrl > '' ? (
					<a href={fileUrl} target="_blank">
						File Uploaded
					</a>
				) : (
					<span>
						{fileName} {fileSize > 0 ? formatBytes(fileSize) : null}
					</span>
				)}
			</div>
			{onDelete ? (
				<div>
					<ButtonBase onClick={handleOnDelete}>
						<Icon
							className="fas fa-times"
							style={{
								fontSize: '0.875rem',
								fontWeight: '400',
								color: gray[700]
							}}
						/>
					</ButtonBase>
				</div>
			) : null}
		</div>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		backgroundColor: gray[300],
		padding: '.25rem .8rem',
		borderRadius: '.375rem',
		display: 'flex'
	},
	textContainer: {
		flex: 1,
		fontFamily: 'Nunito',
		fontSize: '0.8rem',
		display: 'flex',
		alignItems: 'center',
		fontWeight: '600'
	}
}))

export default FileReferenceIndicator
